import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_98: DocMigration = {
  maxSchemaVersion: "0.0.98",
  description: "add under roof to wall types",
  apply(json: any) {
    const allSettings = json.settings;

    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "WALL_SETTINGS") {
        continue;
      }

      const wallConditions = settings.wallConditions;

      if (wallConditions && !wallConditions["INTERIOR_ROOF"]) {
        wallConditions["INTERIOR_ROOF"] = wallConditions["INTERIOR_INTERIOR"]; //set to same wall type as interior to start out
        settings.wallConditions = wallConditions;
      }
    }

    return json;
  },
};

export default migration_0_0_98;
